<template>
  <div>
    <div v-show="buttonShow" class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-button no="Refresh" type="primary" @click="toQuery">{{ $t('FileHistory.Refresh') }}</el-button>
          <el-upload
            :action="URL.common.uploadStorage"
            :headers="{ sessionId: user.sessionId }"
            :show-file-list="false"
            :data="uploadParams"
            :on-success="uploadEnd"
            style="display: inline-block; margin-left: 5px;margin-right: 5px;"
          >
            <el-button no="fileUpload" type="primary">{{ $t('FileHistory.Upload') }}</el-button>
          </el-upload>
          <el-button no="fileDelete" type="danger" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
        </div>
      </div>
    </div>
    <div class="section" style="height: 400px;">
      <cargo-ag-grid
        config-module="136235"
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="rowData"
        :check-sub-record="false"
        style="width:100%;flex:1;"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <!-- 预览文件弹窗 -->
    <pre-view-file-dialog
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :file="previewFileData.file"
      :can-maximize="true"
      @close="closePreviewDialog"
    />
  </div>
</template>

<script>

import URL from '@/api/urlTranslator'
import {
  deleteFile,
  saveMetaData, getFileList
} from '@/api/storage'
import { cacheName, cache } from '@/utils/cacheManager'
import { DocumentCategory } from '@/class/model/sys/DocumentCategory'
import { DocumentManage } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { sortByMultiField } from '@/utils'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import StrUtils from '@/utils/StrUtils'
import * as FileType from '@/class/cargo/model/parameters/FileType'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import preViewFileDialog from '@/components/Cargo/Common/preViewFileCommonDialog'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'GuaranteeFileHistoryTab',
  components: {
    DropUploader,
    preViewFileDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    uuid: {
      type: String,
      required: true
    },
    buttonShow: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function() {
    return {
      URL,
      SystemConstants,
      uploadSource: 'fileHistory',
      source: '7',
      ingotButton: false,
      ingotUploadButton: false,
      user: {},
      sendEmailDialog: {
        visible: false,
        emailTitle: '',
        emailContent: '',
        detailCode: '',
        fileIdList: '',
        fileList: null,
        jobUuidList: null
      },
      storageURL: '',
      fileTypeMap: new Map(),
      fileTypeCapsMap: new Map(), // 按照大写字母匹配
      docType: [],
      job: {},
      fileName: '',
      fileIdList: '',
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中 文件类型
        onCellFocused: (event) => {
          this.onFileTypeCellFocused(event)
        },
        treeData: true,
        getDataPath: data => {
          return (data.path || '').split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('FileHistory.fileName'),
          field: 'fileName',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: false,
            checkbox: params => {
              return true
            }
          }
        }
      },
      columnDefs: [
        {
          headerName: this.$t('FileHistory.fileVersion'),
          field: 'fileVersion',
          width: 100
        },
        {
          headerName: this.$t('FileHistory.jobType'),
          field: 'fileType',
          width: 120,
          cellRenderer: params => {
            return this.fileTypeLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('FileHistory.fileType'),
          field: 'fileFormat',
          width: 120
        },
        {
          headerName: this.$t('FileHistory.fileSize'),
          field: 'fileSize',
          width: 120,
          cellRenderer: params => {
            return this.fileSizeColumnLabel(params.value)
          }
        },
        {
          headerName: this.$t('FileHistory.createdBy'),
          field: 'createdBy',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('FileHistory.createdDate'),
          field: 'createDate',
          width: 120
        },
        {
          headerName: this.$t('FileHistory.Details'),
          field: 'fileId',
          width: 120,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('popFileHistoryDetailFormDialog')
            return `<a onclick="${methodPath}('${params.value}')" style="color:blue">${this.$t('FileHistory.Details')}</a>`
          }
        },
        // {
        //   headerName: this.$t('FileHistory.operation'),
        //   field: 'fileId',
        //   width: 120,
        //   cellRenderer: params => {
        //     let preview = ''
        //     const fileStr = params.data.fileName
        //     const location = fileStr.lastIndexOf('.')
        //     if (JobUtils.canPreviewFile(fileStr.substring(location + 1, fileStr.length))) {
        //       const handlePreviewFile = this.documentManage.getPath('handlePreviewFile')
        //       preview = `<a onclick="${handlePreviewFile}('${params.value}')" style="color:blue">${this.$t('FileHistory.preview')}</a>`
        //     }
        //
        //     const methodOnFileViewPath = this.documentManage.getPath('onFileView')
        //     return `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:blue">
        //             ${this.$t('FileHistory.fileDownload')}
        //             </a>` + preview
        //   }
        // },
        {
          headerName: this.$t('FileHistory.ExternalFileType'),
          field: 'externalFileType',
          width: 120,
          cellRenderer: (params) => {
            return this.externalFileTypeLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      gridApiFileDetail: null,
      gridOptionsFileDetail: {
        context: {
          componentParent: this
        }
      },
      rowDataFileDetail: [],
      defaultDocumentTypeCode: '', // 默认文件类型code
      defaultDocumentChineseName: '', // 默认文件类型中文名
      dropAutoUpload: true, // 拖拽文件后，是否自动上传
      isShowingDetailForm: false,
      showDetailTitle: '',
      documentManage: new DocumentManage(),
      fileTypeEditor: {
        visible: false,
        fileId: '',
        fileCategory: ''
      },
      previewFileData: {
        visible: false,
        file: null
      }
    }
  },
  computed: {
    uploadParams() {
      return {
        guaranteeUuid: this.uuid,
        mbl: '',
        uuid: this.uuid,
        createdBy: this.user.userId,
        createChineseName: this.user.chineseName,
        createEnglishName: this.user.englishName,
        documentType: this.defaultDocumentTypeCode,
        documentName: this.defaultDocumentChineseName,
        isShared: false,
        op: false,
        sales: false,
        cargoSales: false,
        csr: false,
        overseaOp: false,
        dc: false,
        planner: false,
        userDefinedRoleId1: false,
        userDefinedRoleId2: false,
        all: false,
        customer: false,
        consignee: false,
        shipper: false,
        destinationAgent: false,
        bookingAgent: false,
        fileSource: ChargeItemTarget.UPLOAD.code
      }
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    canEditFileType() { // 文件类型是否可以编辑
      return !this.viewSource || (this.viewSource && this.viewSource !== 'trustFromWindow')
    }
  },
  created() {
    this.onShow()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('popFileHistoryDetailFormDialog', function(value) {
      context.popFileHistoryDetailFormDialog(value)
    })
    this.documentManage.set('onFileView', function(value) {
      context.onFileView(value)
    })
    this.documentManage.set('handlePreviewFile', function(value) {
      context.handlePreviewFile(value)
    })
  },
  activated() {
    this.resetDropUpload()
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async onShow() {
      await this.preloadBasicData()
      await this.resetDropUpload()
      this.toQuery()
    },
    async handlePreviewFile(value) {
      const fileObject = this.rowData.find(x => x.fileId === value)

      // CARGO-22751 H5文件历史页签 【预览】没有根据基本配置-文件类型中配置的类型权限控制
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        if (!this.checkDownloadFile(fileObject)) {
          return
        }
      }
      // 检查文件查询权限
      if (fileObject.extendMetaData.hasOwnProperty('documentType')) {
        if (!this.checkFileDocTypeRole(fileObject, true)) {
          return
        }
      }
      this.previewFileData.file = fileObject
      this.previewFileData.visible = true
    },
    // 处理文件后缀名
    getFileType(fileName) {
      let fileType = ''
      if (fileName.indexOf('.') === -1) {
        console.log(this.fileFormat)
        if (this.fileFormat.indexOf('docx') !== -1 || this.fileFormat.indexOf('docx') !== -1 || this.fileFormat.indexOf('word') !== -1 || this.fileFormat.indexOf('xls') !== -1 || this.fileFormat.indexOf('xlsx') !== -1 || this.fileFormat.indexOf('pptx') !== -1) {
          fileType = 'officeType'
        } else if (this.fileFormat.indexOf('pdf') !== -1) {
          fileType = 'pdf'
        } else if (this.fileFormat.indexOf('txt') !== -1) {
          fileType = 'txt'
        }
      } else {
        const arr = fileName.split('.')
        fileType = arr[arr.length - 1].toLowerCase()
      }
      return fileType
    },
    closePreviewDialog() {
      this.previewFileData.file = null
      this.previewFileData.visible = false
    },
    async preloadBasicData() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.configMap = cache.config
    },
    async resetDropUpload() {
      let defaultDocumentTypeCode = ''
      let defaultDocumentChineseName = ''
      this.fileTypeMap.clear()
      this.fileTypeCapsMap.clear()
      this.docType = []
      await DocumentCategory.getDocCategoryTypeTreeByLob({ constructLobParent: false, lob: this.job.lob }).then(res => {
        res.data.forEach(item => {
          if (item.type === 2) {
            const value = this.isZh ? item.chineseName : item.englishName
            this.fileTypeMap.set(item.code, value)
            this.fileTypeCapsMap.set(StrUtils.toUpperCase(item.code), item.chineseName)
            this.docType.push(item)
            if (item.defaultDocumentType) {
              defaultDocumentTypeCode = item.code
              defaultDocumentChineseName = item.chineseName
            }
          }
        })
      })
      this.defaultDocumentTypeCode = defaultDocumentTypeCode
      this.defaultDocumentChineseName = defaultDocumentChineseName
      this.dropAutoUpload = !!defaultDocumentTypeCode
    },
    /* 转换文件类型中文名称*/
    fileTypeLabelFunction: function(value) {
      if (!value) return this.$t('Message.Other')
      let returnVal = ''
      const codes = value.split(',')
      for (let i = 0; i < codes.length; i++) {
        if (returnVal === '') {
          returnVal = this.fileTypeMap.get(codes[i]) || this.$t('Message.Other')
        } else {
          returnVal = returnVal + ',' + (this.fileTypeMap.get(codes[i]) || this.$t('Message.Other'))
        }
      }
      return returnVal
    },
    /* 文件大小转换*/
    fileSizeColumnLabel: function(value) {
      if (value !== '' && !isNaN(value)) {
        return (value / 1024).toFixed(2) + ' KB'
      }
      return ''
    },
    toQuery: async function() {
      this.storageURL = this.configMap.get('StorageURL')
      const xmlParam = '<RequestObject><data><extendMetaData><entry><key>guaranteeUuid</key><value>' +
        this.uuid +
        '</value></entry></extendMetaData></data></RequestObject>'
      await getFileList(xmlParam).then(res => {
        this.rowData = Array.from(res.data, p => {
          return {
            fileId: p.id,
            fileName: p.fileName,
            fileType: p.extendMetaData.documentType || '',
            fileFormat: p.fileType.split(';')[0],
            fileSize: p.fileSize,
            fileVersion: p.fileVersion || '',
            createDate: p.createDate,
            synchronizationState: p.extendMetaData.synchronizationState,
            createChineseName: p.extendMetaData.createChineseName || '',
            createdBy: p.extendMetaData.createdBy,
            fileSource: p.extendMetaData.fileSource || '',
            extendMetaData: p.extendMetaData,
            fileNameBak: p.fileName,
            path: '',
            hasParent: false,
            parentId: ''
          }
        })
      })
      this.getFilesSucceedHandler()
    },
    /* 文件列表 父级和子级组装*/
    getFilesSucceedHandler: function() {
      // 排序后放入临时对象数据
      const rowDataTempt = sortByMultiField(this.rowData, ['fileName', 'fileVersion', 'createDate'], true)
      if (!rowDataTempt || rowDataTempt.length === 0) {
        return
      }
      let fatherFile = rowDataTempt[0]
      // 初始化 首个父节点的path
      fatherFile.path = fatherFile.fileId
      fatherFile.hasParent = false
      const source = []
      source.push(fatherFile)
      let childFile
      for (let i = 1; i < rowDataTempt.length; i++) {
        childFile = rowDataTempt[i]
        childFile.hasParent = false
        if (childFile.fileName === fatherFile.fileName && childFile.fileSource === fatherFile.fileSource) {
          if (fatherFile.hasParent) {
            childFile.path = fatherFile.parentId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.parentId
          } else {
            childFile.path = fatherFile.fileId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.fileId
          }
          // childFile.fileName = ''
        } else {
          // 遍历到父节点了
          childFile.path = childFile.fileId
        }
        source.push(childFile)
        fatherFile = childFile
      }
      // 数据组装后 父级再次排序 根据createDate fileName
      let parentFileList = source.filter(val => {
        return val.hasParent === false
      })
      const childFileList = source.filter(val => {
        return val.hasParent === true
      })
      parentFileList = sortByMultiField(parentFileList, ['createDate', 'fileName'], true)

      this.rowData = [...parentFileList, ...childFileList]
    },
    onFileView(value) {
      const fileObject = this.rowData.find(x => x.fileId === value)

      // 判断是否有下载文件的权限
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        if (!this.checkDownloadFile(fileObject)) {
          return
        }
      }
      // 检查文件查询权限
      if (fileObject.extendMetaData.hasOwnProperty('documentType')) {
        if (!this.checkFileDocTypeRole(fileObject, true)) {
          return
        }
      }

      const url = URL.common.findByFileId + `/${value}?sessionId=${this.context.user.sessionId}`
      window.open(url)
    },
    checkDownloadFile(data) {
      if (Number(data.createdBy) !== this.user.userId) {
        this.$message.warning(this.$t('SeaExport.NoPermissionToViewOrprinted'))
        return false
      }
      return true
    },
    checkFileDocTypeRole(data, isMarked) {
      let documentType = data.extendMetaData.documentType
      if (documentType === this.$t('Message.Other')) {
        documentType = 'OTHER'
      }
      if (documentType === 'other' || documentType === 'Other') {
        documentType = documentType.toLocaleUpperCase()
      }
      const result = this.getDocType(documentType)
      if (!result || result.length === 0) {
        return true
      }

      if (this.user.admin || parseInt(data.createdBy) === this.user.userId) {
        return true
      }
      const fileRoleMap = this.getFileRoleMap(result)
      if (fileRoleMap.length === 0) {
        // 查看或下载的操作进行弹窗
        if (isMarked) {
          this.$message.warning(this.$t('SeaExport.FileNotAllowedView').replace('{0}', data.fileName))
        }
        return false
      }
      let isView = false
      if (this.$checkPermission(['role_sales']) && fileRoleMap.indexOf('sales') !== -1) {
        isView = true
      }
      if (this.$checkPermission(['role_op']) && fileRoleMap.indexOf('op') !== -1) {
        isView = true
      }
      // 揽货销售
      if (this.$checkPermission(['role_salesOfGoods']) && fileRoleMap.indexOf('cargoSales') !== -1) {
        isView = true
      }
      // 客服
      if (this.$checkPermission(['role_csr']) && fileRoleMap.indexOf('csr') !== -1) {
        isView = true
      }
      // 海外客服
      if (this.$checkPermission(['role_overseaOp']) && fileRoleMap.indexOf('overseaOp') !== -1) {
        isView = true
      }
      // 单证
      if (this.$checkPermission(['role_doc']) && fileRoleMap.indexOf('dc') !== -1) {
        isView = true
      }
      // 航线负责人
      const lob = this.job ? this.job.lob : ''
      let isPermission = false
      if (lob === SystemConstants.SE.code || lob === SystemConstants.SI.code) {
        isPermission = this.$checkPermission(['role_sealine']) // 海运
      } else if (lob === SystemConstants.AE.code || lob === SystemConstants.AI.code) {
        isPermission = this.$checkPermission(['role_airline']) // 空运
      } else if (lob === SystemConstants.RE.code || lob === SystemConstants.RI.code) {
        isPermission = this.$checkPermission(['role_railwayLine']) // 铁路
      }
      if (isPermission && fileRoleMap.indexOf('planner') !== -1) {
        isView = true
      }
      // 自定义岗位Id1
      if (this.$checkPermission(['role_userDefinedRole1']) && fileRoleMap.indexOf('userDefinedRoleId1') !== -1) {
        isView = true
      }
      // 自定义岗位Id2
      if (this.$checkPermission(['role_userDefinedRole2']) && fileRoleMap.indexOf('userDefinedRoleId2') !== -1) {
        isView = true
      }
      if (!isView && fileRoleMap.indexOf('all') !== -1) {
        isView = true
      }
      // 查看或下载的操作进行弹窗
      if (!isView && isMarked) {
        this.$message.warning(this.$t('SeaExport.NoPermissionToView').replace('{0}', data.fileName))
        return
      }
      return isView
    },
    //  文档属性权限
    getFileRoleMap(result) {
      const fileRoleMap = []
      if (this.getDocTypeRole('sales', result)) {
        fileRoleMap.push('sales')
      }
      if (this.getDocTypeRole('op', result)) {
        fileRoleMap.push('op')
      }
      if (this.getDocTypeRole('cargoSales', result)) {
        fileRoleMap.push('cargoSales')
      }
      if (this.getDocTypeRole('csr', result)) {
        fileRoleMap.push('csr')
      }
      if (this.getDocTypeRole('overseaOp', result)) {
        fileRoleMap.push('overseaOp')
      }
      if (this.getDocTypeRole('dc', result)) {
        fileRoleMap.push('dc')
      }
      if (this.getDocTypeRole('planner', result)) {
        fileRoleMap.push('planner')
      }
      if (this.getDocTypeRole('userDefinedRoleId1', result)) {
        fileRoleMap.push('userDefinedRoleId1')
      }
      if (this.getDocTypeRole('userDefinedRoleId2', result)) {
        fileRoleMap.push('userDefinedRoleId2')
      }
      if (this.getDocTypeRole('all', result)) {
        fileRoleMap.push('all')
      }
      return fileRoleMap
    },
    onFileTypeCellFocused(event) {
      if (event.column && event.column && event.column.colId === 'fileType' && this.canOperateJob && this.canEditFileType) {
        const selected = this.getSelectedHandler(event)
        // 被同步的文件不可编辑
        if (selected.extendMetaData['sourceId']) {
          this.$message.warning(this.$t('Message.TheSynchronizedFileCannotBeEdited'))
          return
        }
        if (selected) {
          if (!this.user.admin && !this.$checkPermission(['role_FileHistory_editAllFile'])) {
            if (Number(selected.createdBy) !== this.user.userId) {
              this.$message.warning(this.$t('Message.NotPermissionToEditFilesByOtherUsers'))
              return
            }
          }
          this.fileTypeEdit(selected)
        }
      }
    },
    getSelectedHandler(event) {
      let selectData = null
      this.gridOptions.api.forEachNode(node => {
        if (node.rowIndex === event.rowIndex) {
          selectData = node.data
        }
      })
      return selectData
    },
    fileTypeEdit(data) {
      this.fileTypeEditor.fileId = data.fileId
      this.fileTypeEditor.fileCategory = data.fileType
      this.fileTypeEditor.visible = true
    },
    // 文件类型 编辑保存
    async itemEditEndHandler(data) {
      const item = this.rowData.find(p => p.fileId === data.fileId)
      const documentType = data.fileCategory
      const documentName = data.fileCategoryLabel // item.extendMetaData['documentName']
      if (item.extendMetaData && data && data.docTypeRows && data.docTypeRows.length > 0) {
        const docType = data.docTypeRows[0]
        if (!docType) {
          return
        }
        item.extendMetaData = JobUtils.setUploadFileParam(item.extendMetaData, docType)
      }
      const isShared = item.extendMetaData['isShared']
      const op = item.extendMetaData['op']
      const sales = item.extendMetaData['sales']
      const cargoSales = item.extendMetaData['cargoSales']
      const csr = item.extendMetaData['csr']
      const overseaOp = item.extendMetaData['overseaOp']
      const dc = item.extendMetaData['dc']
      const planner = item.extendMetaData['planner']
      const userDefinedRoleId1 = item.extendMetaData['userDefinedRoleId1']
      const userDefinedRoleId2 = item.extendMetaData['userDefinedRoleId2']
      const all = item.extendMetaData['other']
      const customer = item.extendMetaData['customer']
      const consignee = item.extendMetaData['consignee']
      const b2bCustomer = item.extendMetaData['b2bCustomer']
      const b2bDesignationAgent = item.extendMetaData['b2bDesignationAgent']
      const b2bDestinationAgent = item.extendMetaData['b2bDestinationAgent']
      const b2bConsignee = item.extendMetaData['b2bConsignee']
      const shipper = item.extendMetaData['shipper']
      const destinationAgent = item.extendMetaData['destinationAgent']
      const bookingAgent = item.extendMetaData['bookingAgent']
      const synchronizationState = item.extendMetaData['synchronizationState']
      const xmlParam = `<RequestObject>
      <fileId>${item.fileId}</fileId>
      <extendMetaData>
      <entry>
      <key>documentType</key>
      <value>${documentType}</value>
      </entry>
      <entry>
      <key>documentName</key>
      <value>${documentName}</value>
      </entry>
      <entry>
      <key>isShared</key>
      <value>${isShared}</value>
      </entry>
      <entry>
      <key>op</key>
      <value>${op}</value>
      </entry>
      <entry>
      <key>sales</key>
      <value>${sales}</value>
      </entry>
      <entry>
      <key>cargoSales</key>
      <value>${cargoSales}</value>
      </entry>
      <entry>
      <key>csr</key>
      <value>${csr}</value>
      </entry>
      <entry>
      <key>overseaOp</key>
      <value>${overseaOp}</value>
      </entry>
      <entry>
      <key>dc</key>
      <value>${dc}</value>
      </entry>
      <entry>
      <key>planner</key>
      <value>${planner}</value>
      </entry>
      <entry>
      <entry>
      <key>userDefinedRoleId1</key>
      <value>${userDefinedRoleId1}</value>
      </entry>
      <entry>
      <key>userDefinedRoleId2</key>
      <value>${userDefinedRoleId2}</value>
      </entry>
      <key>all</key>
      <value>${all}</value>
      </entry>
      <entry>
      <key>customer</key>
      <value>${customer}</value>
      </entry>
      <entry>
      <key>consignee</key>
      <value>${consignee}</value>
      </entry>
      <entry>
      <key>b2bCustomer</key>
      <value>${b2bCustomer}</value>
      </entry>
      <entry>
      <key>b2bDesignationAgent</key>
      <value>${b2bDesignationAgent}</value>
      </entry>
      <entry>
      <key>b2bDestinationAgent</key>
      <value>${b2bDestinationAgent}</value>
      </entry>
      <entry>
      <key>b2bConsignee</key>
      <value>${b2bConsignee}</value>
      </entry>
      <entry>
      <key>shipper</key>
      <value>${shipper}</value>
      </entry>
      <entry>
      <key>destinationAgent</key>
      <value>${destinationAgent}</value>
      </entry>
      <entry>
      <key>bookingAgent</key>
      <value>${bookingAgent}</value>
      </entry>
      <entry>
      <key>synchronizationState</key>
      <value>${synchronizationState}</value>
      </entry>
      </extendMetaData>
      </RequestObject>`
      await saveMetaData(xmlParam)
      this.toQuery()
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const fileDeleteRole = this.$checkPermission(['button_FileHistory_fileDelete'])
      const ownFileDeleteRole = this.$checkPermission(['role_FileDownloads_ownFileDelete'])
      for (const item of rows) {
        if (!fileDeleteRole && ownFileDeleteRole) {
          if (!item.extendMetaData || (this.$store.getters.userId !== Number(item.extendMetaData.createdBy))) {
            this.$message.warning(this.$t('CargoMsg.Cargo_OwnFileDelete'))
            return
          }
        }
      }
      this.$confirm(this.$t('SeaExport.DeleteNumFile').replace('{0}', rows.length), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        try {
          for (const item of rows) {
            if (item.sourceId) {
              this.$message.warning(this.$t('Message.TheSynchronizedFileIsNotDeleted'))
              return
            }
            const data = {
              fileName: item.fileName,
              jobUuid: this.uuid,
              branchId: this.$store.getters.currentOfficeId
            }
            const isSuccess = await deleteFile(item.fileId, data).then(res => res.data === 'success')
            if (isSuccess) {
              item.isDeleted = true
            } else {
              break
            }
          }
        } finally {
          this.rowData = this.rowData.filter(p => !p.isDeleted)
          this.getFilesSucceedHandler()
        }
      }).catch(() => {
      })
    },
    // 查看详情
    popFileHistoryDetailFormDialog: function(value) {
      this.isShowingDetailForm = true
      const fileObject = this.rowData.find(x => x.fileId === value)
      const extendMetaData = fileObject.extendMetaData
      this.showDetailTitle = fileObject.fileName + '_' + fileObject.fileVersion

      const roles = ['op', 'sales', 'cargoSales', 'csr', 'overseaOp', 'dc', 'planner', 'all', 'customer', 'consignee', 'shipper', 'destinationAgent', 'bookingAgent', 'userDefinedRoleId1', 'userDefinedRoleId2', 'b2bCustomer', 'b2bDesignationAgent', 'b2bDestinationAgent', 'b2bConsignee']

      var docTypeFilter = null
      // 文件类型转换
      if (extendMetaData.hasOwnProperty('documentType')) {
        var documentType = extendMetaData.documentType
        if (documentType === this.$t('Message.Other')) {
          documentType = 'OTHER'
        }
        if (documentType === 'other' || documentType === 'Other') {
          documentType = documentType.toLocaleUpperCase()
        }
        //  根据文件类型code 获取相关属性
        docTypeFilter = this.getDocType(documentType)
      }

      const extendMetaDataSort = this.objKeySort(extendMetaData)
      const tempFileDetailList = []
      for (const key in extendMetaDataSort) {
        if (key === 'entry' || key === 'createdBy') {
          continue
        }
        let keyValue
        if (roles.includes(key) && docTypeFilter != null) {
          keyValue = this.getDocTypeRole(key, docTypeFilter) ? this.$t(`SeaExport.Accessible`) : ''
        } else {
          keyValue = extendMetaData[key]
        }
        const convertKeyName = this.keyLabFunc(key)

        var keyName
        keyName = this.$t(`SeaExport.${convertKeyName}`)
        if (keyName === 'SeaExport.') {
          keyName = key
        }
        /* 资源文件未转义 特殊处理直接赋值*/
        if (keyName === 'SeaExport.bookingAgent') {
          keyName = this.$t('SeaExport.BookingAgent')
        }
        if (key === 'userDefinedRoleId1') {
          keyName = this.$t('CargoMsg.Cargo_userDefinedRole1')
        }
        if (key === 'userDefinedRoleId2') {
          keyName = this.$t('CargoMsg.Cargo_userDefinedRole2')
        }
        if (keyName === 'SeaExport.hblNo') {
          keyName = 'hbl'
        }
        const json = { 'key': keyName, 'val': keyValue }
        tempFileDetailList.push(json)
      }
      this.rowDataFileDetail = tempFileDetailList
    },
    // 获取 获取属性访问权限
    getDocTypeRole(roleKey, docType) {
      if (docType === null || docType.length === 0) {
        return false
      }
      if (roleKey === 'all') {
        roleKey = 'other'
      }
      for (let i = 0; i < docType.length; i++) {
        if (docType[i][roleKey]) {
          return true
        }
      }

      return false
    },
    // 获取code所关联的XML 原cargo getDocTypeXml
    getDocType(codes) {
      const docTypeFilter = []
      if (codes == null || codes === '') {
        return null
      }
      const codeArray = codes.split(',')
      for (let i = 0; i < codeArray.length; i++) {
        const docObject = this.docType.find(x => x.code === codeArray[i])
        if (docObject != null) {
          docTypeFilter.push(docObject)
        }
      }
      return docTypeFilter
    },
    /* json 根据 key 的名称排序的函数*/
    objKeySort(obj) {
      var newkey = Object.keys(obj).sort()
      var newObj = {}
      for (var i = 0; i < newkey.length; i++) {
        newObj[newkey[i]] = obj[newkey[i]]
      }
      return newObj
    },
    // 转换对应的 中文定义的keyName
    keyLabFunc(value) {
      let convertKeyName = ''
      switch (value) {
        case 'op':
          convertKeyName = 'Operation'
          break
        case 'sales':
          convertKeyName = 'Sales'
          break
        case 'cargoSales':
          convertKeyName = 'SalesOfGoods'
          break
        case 'csr':
          convertKeyName = 'CustomerService'
          break
        case 'overseaOp':
          convertKeyName = 'OverseaCustomerService'
          break
        case 'dc':
          convertKeyName = 'Documents'
          break
        case 'planner':
          convertKeyName = 'AirlinePerson2'
          break
        case 'all':
          convertKeyName = 'AllPositions'
          break
        case 'customer':
          convertKeyName = 'ConsignationCompany'
          break
        case 'consignee':
          convertKeyName = 'Consignee'
          break
        case 'shipper':
          convertKeyName = 'Shipper'
          break
        case 'destinationAgent':
          convertKeyName = 'DestinationAgent'
          break
        case 'bookingAgent':
          convertKeyName = 'bookingAgent'
          break
        case 'hblNo':
          convertKeyName = 'hblNo'
          break
        case 'hblRefNo':
          convertKeyName = 'hblRefNo'
          break
      }
      return convertKeyName
    },
    sendEmail() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectAFileToDownloadOrSend'))
        return
      }

      if (this.validateSendEmail(rows)) {
        return
      }

      this.sendEmailDialog.visible = true
      this.sendEmailDialog.emailTitle = Array.from(rows, p => p.fileName).reduce((a, b) => a + ';' + b)
      this.sendEmailDialog.fileIdList = Array.from(rows, p => p.fileId).reduce((a, b) => a + ',' + b)
      this.sendEmailDialog.fileList = rows
    },
    validateSendEmail(fileList) {
      if (!fileList || fileList.length <= 0) return true
      let fileNames = ''
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        for (const file of fileList) {
          if (Number(file.createdBy) !== this.user.userId) {
            fileNames = fileNames + '【' + file.fileName + '】'
          }
        }
      }
      if (fileNames) {
        this.$message.warning(this.$t('Message.NotPermissionToViewFiles', [fileNames]))
        return true
      }
      for (const file of fileList) {
        if (file.extendMetaData.hasOwnProperty('documentType')) {
          if (!this.checkFileDocTypeRole(file, false)) {
            fileNames = fileNames + '【' + file.fileName + '】'
          }
        }
      }
      if (fileNames) {
        this.$message.warning(this.$t('Message.NotPermissionToViewFiles', [fileNames]))
        return true
      }
    },
    uploadEnd() {
      this.toQuery()
    },
    externalFileTypeLabelFunc(value) {
      if (!value) return ''
      for (const common of FileType.EXTERNAL_FILE_TYPES) {
        if (common.code === value) {
          return common.chineseName
        }
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
